import { compose, maxLength, required } from "utils/validators";

const validReplyAddressPrefixRegex = /^[a-z0-9]+((-|_|\.)[a-z0-9]+)*$/;

export const displayNameValidation = compose(
  required("Display name is required"),
  maxLength("Enter a max. of 80 characters", 80)
);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const replyAddressValidation = (prefix: string, emailDomainID: string | null) => {
  if (emailDomainID !== null) {
    return compose(required("Reply address prefix can't be blank"), (value: string) =>
      validReplyAddressPrefixRegex.test(value)
        ? ""
        : "Prefix has invalid format. Only numbers, letters and ‘-’, ’_’, `.`  are allowed."
    )(prefix);
  }

  return "";
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const teamCountValidation = (teams: string[]) => {
  return teams.length === 0 ? "Select at least one team" : "";
};
